<div class="row">
    <h3>Your password has been reset, an email with your new password will be sent soon.</h3>
  </div>
  